import { appColors } from './theme';

export const getMainStyles = (theme) => ({
    appContainer: {
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
        width: '100%',
        backgroundColor: theme.palette.background.default,
    },
    creditContainer: {
        height: '36px',
        width: '100%',
        background: `linear-gradient(90deg, ${theme.palette.warning.main} 0%, ${theme.palette.warning.dark} 100%)`,
        position: 'fixed',
        top: 0,
        left: 0,
        zIndex: 1000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: theme.spacing(1.5),
        fontSize: '0.8125rem',
        fontWeight: 500,
        color: theme.palette.grey[900],
    },
    layoutContainer: (showCreditWarning) => ({
        display: 'flex',
        flex: 1,
        marginTop: showCreditWarning ? '36px' : 0,
        height: showCreditWarning ? 'calc(100vh - 36px)' : '100vh',
    }),
    sidebarContainer: (showCreditWarning) => ({
        width: '85px',
        position: 'fixed',
        top: showCreditWarning ? '36px' : '0',
        height: showCreditWarning ? 'calc(100vh - 36px)' : '100vh',
        left: 0,
        zIndex: 900,
        [theme.breakpoints.down('md')]: {
            width: '56px',
        },
        [theme.breakpoints.down('sm')]: {
            display: 'none',
        },
    }),
    rightSection: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        marginLeft: '85px',
        height: '100%',
        minWidth: 0,
        [theme.breakpoints.down('md')]: {
            marginLeft: '56px',
        },
        [theme.breakpoints.down('sm')]: {
            marginLeft: 0,
        },
    },
    mainNavbar: {
        height: '56px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexShrink: 0,
        backgroundColor: appColors.page.background,
    },
    mainContent: {
        flex: 1,
        overflowY: 'auto',
        backgroundColor: theme.palette.background.default,
    },

    addBtn: {
        minWidth: '80px',
        height: '28px',
        borderRadius: '8px',
        backgroundColor: appColors.button.primary,
        color: appColors.button.primaryText,
        fontSize: '0.75rem',
        fontWeight: 600,
        marginLeft: theme.spacing(1.5),
        '&:hover': {
            backgroundColor: appColors.button.primaryHover,
        },
    },

    // Cards
    cardHeader: {
        borderRadius: 0,
        boxShadow: 'none',
        fontFamily: theme.typography.fontFamily,
    },
    noRecord: {
        display: "flex",
        flexDirection: 'column',
        justifyContent: "center",
        alignItems: "center",
        width: '100%',
        height: '100%',
        textAlign: "center",
        color: theme.palette.text.disabled,
        gap: theme.spacing(1),
    },

    // Loadbar
    loadbarContainer: {
        top: 0,
        left: 0,
        width: '100%',
        position: 'fixed',
        zIndex: 9999,
    },
    loadbar: {
        height: 3,
        '& .MuiLinearProgress-bar': {
            backgroundColor: theme.palette.primary.main,
        },
    },

    // Tabs
    activateTab: {
        '& .MuiTabs-indicator': { backgroundColor: theme.palette.primary.main, height: '2px' },
        '& .Mui-selected': {
            color: theme.palette.primary.main,
        },
    },
    tabs: {
        '& .MuiTab-root': {
            textTransform: 'none',
            fontWeight: 500,
        },
        '& .Mui-selected': {
            color: theme.palette.primary.main,
            fontWeight: 600,
        },
    },

    // Side Drawer
    sideDrawerContainer: {
        width: '480px',
        backgroundColor: theme.palette.background.paper,
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        padding: theme.spacing(3),
        overflow: 'auto',
        maxWidth: '100vw',
        borderLeft: `1px solid ${theme.palette.divider}`,
        [theme.breakpoints.down('sm')]: {
            width: '100vw',
        },
    },

    ameya_icon: {
        width: '24px',
        height: '24px',
        objectFit: 'cover',
        borderRadius: '6px',
        backgroundColor: theme.palette.grey[100],
    },

    // Svg Icons
    svgIcons: {
        height: '24px',
        width: '24px',
        color: '#FFFFFF',
        stroke: '#FFFFFF',
    },

    // Delete Modal
    modalcontainer: {
        position: 'absolute',
        left: '50%',
        top: '50%',
        width: '90%',
        maxWidth: '480px',
        backgroundColor: theme.palette.background.paper,
        borderRadius: '16px',
        padding: theme.spacing(4),
        transform: 'translate(-50%,-50%)',
        border: 'none',
        boxShadow: '0 25px 50px -12px rgba(0,0,0,0.25)',
        [theme.breakpoints.down('sm')]: {
            width: '95%',
            padding: theme.spacing(3),
        },
    },
    mainWarning: {
        fontSize: '1.25rem',
        fontWeight: 700,
        color: theme.palette.text.primary,
        lineHeight: 1.3,
    },
    subWarning: {
        fontSize: '0.875rem',
        fontWeight: 400,
        color: theme.palette.text.secondary,
        marginTop: theme.spacing(1.5),
        lineHeight: 1.6,
    },
    confirmButtonGroup: {
        marginTop: theme.spacing(3),
        display: 'flex',
        justifyContent: 'flex-end',
        gap: theme.spacing(1.5),
    },
    confirmDelete: {
        minWidth: '100px',
        height: '36px',
        backgroundColor: theme.palette.error.main,
        color: '#FFFFFF',
        fontSize: '0.875rem',
        fontWeight: 600,
        borderRadius: '8px',
        border: 'none',
        cursor: 'pointer',
        transition: 'all 0.15s ease',
        '&:hover': {
            backgroundColor: theme.palette.error.dark,
        },
    },
    cancelDelete: {
        minWidth: '100px',
        height: '36px',
        backgroundColor: 'transparent',
        color: theme.palette.text.primary,
        fontSize: '0.875rem',
        fontWeight: 500,
        borderRadius: '8px',
        border: `1px solid ${theme.palette.divider}`,
        cursor: 'pointer',
        transition: 'all 0.15s ease',
        '&:hover': {
            backgroundColor: theme.palette.grey[50],
            borderColor: theme.palette.grey[400],
        },
    },
})
